import { Chip } from "@mui/material";
import { QuestCreateStatusValue } from "@quest_editor/constants";
import { getQuestCreateStatusOptions } from "@quest_editor/utils/view/constLabels";

type ChipColor =
  | "default"
  | "primary"
  | "secondary"
  | "error"
  | "info"
  | "success"
  | "warning";

const statusColorMap: Record<QuestCreateStatusValue, ChipColor> = {
  waiting: "error",
  done: "info",
};

const QuestCreateStatusChip = ({ status }: { status: QuestCreateStatusValue }) => {
  const questCreateStatuses = getQuestCreateStatusOptions();
  const label =
    questCreateStatuses.find((qcs) => qcs.value === status)?.label ?? status;
  const color = statusColorMap[status] || "default";

  return <Chip label={label} color={color} size="small" />;
};

export default QuestCreateStatusChip;
